export default __webpack_public_path__ + "images/aaf1581add17780336ec99e330ee46c6-x-red.svg";